/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Liwg
 * @date  2025/05/06 18:04
 * @des  需要国际化的英文
 */

const i18nCOMMON_EN = require('../../common/i18n/en')

module.exports = {
  ...i18nCOMMON_EN,
  padcontrol: {
    appName: '小雨优学智能',
    title0: '家长专属的智能学习管家，一站式管理学习机，让家庭教育更轻松、更高效。',
    title1: '通过小雨优学智能App，家长可远程管控小雨优学学习机，实时掌握孩子学习动态，帮助孩子科学规划学习，提升自主学习能力。',
    copyright: 'Copyright ©2025 Chianyu All Rights Reserved 武汉前雨信息技术有限公司 版权所有'
  }
}



// WEBPACK FOOTER //
// ./src/pad-control/i18n/en.js